import React from 'react';
import { Box, Stack } from '@mui/material';
import { useIntl } from 'react-intl';
import { Actions, Burger as BurgerIcon } from '@linetweet/linetweet-ui';

import styles from './index.module.scss';
// import { Authorized, Roles } from '../Auth';


type IProps = {
  openNavigationMenu: () => void;
  urls: {
    diwa?: string;
    booking?: string;
    settings?: string;
  }
}

const Header = (props: IProps) => {
  const { openNavigationMenu } = props;
  const intl = useIntl();

  return (
    <Box className={styles.header}>
      <Box className={styles.leftBlock}>
        <Box className={styles.iconWrapper} onClick={openNavigationMenu}>
          <BurgerIcon width={22} height={24} />
        </Box>
        <Box className={styles.title}>
          <Stack direction={'row'} gap={1} alignItems={'center'}>
            {intl.formatMessage({ id: 'common.appTitle' })}
            {/* <Authorized roles={[Roles.SETTINGS_ADMIN]}>
              <Chip label='Admin' color='success' size={'small'} />
            </Authorized> */}
          </Stack>
        </Box>
      </Box>

      <Actions availableBlocks={['appointment', 'settings']} urls={props.urls} currentlySelected={'performance-tracker'} />

      {/* <Authorized roles={[Roles.MANAGER]}>
        <Actions availableBlocks={['appointment']} urls={props.urls} currentlySelected={'settings'} />
      </Authorized> */}
    </Box>
  );
};

export default Header;
